// extracted by mini-css-extract-plugin
export default {"StatsItem":"style_StatsItem__5V-N1"};